"use client";

import { useLayoutEffect } from "react";

export function ProviderProfileScrollReset() {
  useLayoutEffect(() => {
    if (window.location.hash) return;
    window.scrollTo({ left: 0, top: 0 });
  }, []);

  return null;
}
